module.exports = __webpack_public_path__ + "img/slider_galery_25.cfdc55e1.jpg";